import ar from './ar.json';
import en from './en.json';

/**
 * The Integrations module's catalogue, registered from `app.config.tsx` under the
 * `integrations` namespace — `shared/i18n` never imports a module (W2).
 *
 * The capability and provider KEYS come from the contracts catalog; only the prose
 * around them lives here, so adding a provider needs a line of copy rather than a
 * change to the panel.
 */
export const integrationsCatalogs = { ar, en };
